module.exports = __webpack_public_path__ + "static/media/trophy-award-winner-svgrepo-com.5baa4fab.svg";